module.exports = __webpack_public_path__ + "static/media/build.2c83879f.svg";